(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/themes/sport-floorball/views/match/stat-team-player-statistics.js') >= 0) return;  svs.modules.push('/components/themes/sport-floorball/views/match/stat-team-player-statistics.js'); (function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.themes=_svs.themes||{};
_svs.themes.sport_floorball=_svs.themes.sport_floorball||{};
_svs.themes.sport_floorball.templates=_svs.themes.sport_floorball.templates||{};
svs.themes.sport_floorball.templates.stat_team_player_statistics = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "\n  <div class=\"span12 f-center padding-top-1\">\n  Ingen lagstatistik tillgänglig.\n  </div>\n";
},"useData":true});
Handlebars.partials['components-themes-sport_floorball-stat_team_player_statistics'] = svs.themes.sport_floorball.templates.stat_team_player_statistics;
})(svs, Handlebars);

 })(window);